module.exports = __webpack_public_path__ + "media/images/icons/outlined/warning-9cb655e0302810ce5d67bc1bc758c051.svg";